export { getFileTypeLabels, getAcceptedMimeTypes } from './fileTypes';
export { isiOS } from './getOs';
export { getQueryParamMap, updateQueryString } from './query-params';
export { extractThumbnailPath } from './extractThumbnailPath';
export { copyToClipboard } from './copyToClipboard';
export { getFileSizeLabel } from './getFileSize';
export { getMediaChipMap } from './getMediaChipMap';
export { formatDateMmDdYyyy } from './date-utils';
export { isValidHexCode, isValidRgba } from './validations';
export { deepEquals } from './deep-equals';
export { getPlanUpgrade } from './plan-helpers';
export * from './pagination-utils';
export * from './string-utils';



// WEBPACK FOOTER //
// ./src/utils/index.js